import { useQuery } from '@tanstack/vue-query'
import { userInfo as userInfoAPI } from '@mp/api/gateway/UserControler.ts'
import { computed } from 'vue'

export function useUserInfo() {
  const { data: userInfo, refetch: refetchUserInfo, isLoading: userInfoLoading, isFetching: userInfoFetching } = useQuery({
    queryKey: ['get:user:info'],
    queryFn: () => userInfoAPI({}),
    select: (res) => {
      const token = res.userInfo?.token
      if (token)
        sessionStorage.token = token
      else sessionStorage.removeItem('token')

      const signType = res.userInfo?.signType
      if (signType)
        sessionStorage.signType = signType
      else sessionStorage.removeItem('signType')

      const operatorId = res.userInfo?.operatorId
      if (operatorId)
        sessionStorage.operatorId = operatorId
      else sessionStorage.removeItem('operatorId')

      return res?.userInfo
    },
    refetchOnWindowFocus: false,
  })

  // ? 是否是管理员
  const isAdmin = computed(() => userInfo.value?.operatorType === 'default')

  // ? 是否是总部商户
  const isHeadOffice = computed(() => userInfo.value?.businessType === 'COMPANY')

  return {
    userInfo,
    isAdmin,
    isHeadOffice,
    refetchUserInfo,
    userInfoLoading: userInfoLoading || userInfoFetching,
  }
}
